export const HEADING_TAG_NAME = "heading" as const;

export const HEADING_SIZES = ["sm", "md", "lg", "xl", "xxl"] as const;
